import Default from "../../assets/default.svg";
import Docx from "../../assets/doc.svg";
import Jpg from "../../assets/jpg.svg";
import Pdf from "../../assets/pdf.svg";
import Png from "../../assets/png.svg";
import Svg from "../../assets/svg.svg";
import Txt from "../../assets/txt.svg";
import Xls from "../../assets/xls.svg";
import { FileExtractionStatus } from "../../models/jobStatus";

export const getIcon = (type: string) => {
  const iconMappings: Record<string, string> = {
    "application/pdf": Pdf,
    "image/svg+xml": Svg,
    "image/jpeg": Jpg,
    "image/png": Png,
    "text/plain": Txt,
  };
  if (type?.includes("spreadsheet") || type?.includes("excel")) return Xls;
  if (type?.includes("wordprocessing") || type?.includes("word")) return Docx;
  return iconMappings[type] || Default;
};

export const formatFileSize = (fileSizeInBytes: number) => {
  if (fileSizeInBytes < 1024) {
    return `${fileSizeInBytes} bytes`;
  }
  if (fileSizeInBytes < 1048576) {
    // Less than 1 MB, convert to KB
    return `${(fileSizeInBytes / 1024).toFixed(2)} KB`;
  }
  if (fileSizeInBytes < 1073741824) {
    // Less than 1 GB, convert to MB
    return `${(fileSizeInBytes / 1048576).toFixed(2)} MB`;
  }
  // Larger than 1 GB, convert to GB
  return `${(fileSizeInBytes / 1073741824).toFixed(2)} GB`;
};

export const steps = [
  FileExtractionStatus.ExtractionStarted,
  FileExtractionStatus.DocumentIntelligence,
  FileExtractionStatus.ExtractionCompleted,
];

export const getErrorMessage = (error: string) => {
  switch (error) {
    case "file-invalid-type":
      return "The uploaded file is of an invalid type.";
    case "file-too-large":
      return "The file size exceeds the maximum allowed limit.";
    default:
      return "An error occurred during the operation. Please try again later.";
  }
};
